// Components
import Navbar from "../../components/Navbar/navbar";
import Intro from "../../components/Intro/intro";
import MeetTheBand from "../../components/MeetTheBand/MeetTheBand";
import BandMembers from "../../components/BandMembers/BandMembers";
import Media from "../../components/media/media";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import SongsBrowser from "../../components/ohjelmisto/ohjelmisto";
import FAQ from "../../components/FAQ/FAQ";
import JoyrideBookingEmbed from "../../components/JoyrideBookingEmbed/JoyrideBookingEmbed.jsx";

export default function Home() {
  return (
    <>
      <Navbar />
      <div className="container">
        <Intro />
        <MeetTheBand />
        <Media />
        <BandMembers />
        <SongsBrowser />
        <FAQ />
      </div>

      <JoyrideBookingEmbed />

      <ScrollToTop />
    </>
  );
}